/**
 *
 * CollaboratorsSummary
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Modal, Button, Progress } from "antd"
import check from "../../images/check.svg"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import {
  makeSelectSummary,
  makeSelectIsLoadingSummary,
  makeSelectPercentage,
  makeSelectError,
} from "./selectors"
import {
  getCollaboratorsSummaryWatcher,
  uploadTemplateCollaboratorsWatcher,
  saveExcelCollaboratorsWatcher,
  getCeasedSummaryWatcher,
  uploadTemplateCeasedWatcher,
  saveCollaboratorsCeasedWatcher,
  getTeamsSummaryWatcher,
  saveTeamsWatcher,
  uploadTemplateTeamsWatcher,
  getDivisionsAssignmentSummaryWatcher,
  saveExcelDivisionsAssignmentWatcher,
  uploadTemplateDivisionsAssignmentWatcher,
} from "./actions"
import reducer from "./reducer"
import saga from "./saga"

import SummaryScreen from "components/SummaryScreen"
import Loader from "components/Loader"
import { pick, get } from "lodash"

import { makeSelectHasCollaborators } from "../Collaborators/selectors"
import {
  KEY_TIMESTAMP_COLLABORATORS_IMPORT,
  LOCAL_TIMESTAMP_COLLABORATORS_IMPORT,
  setItem,
} from "../../utils/storage"
import { assignDivisions } from "../../services/logs"

/* eslint-disable react/prefer-stateless-function */
export class CollaboratorsSummary extends React.Component {
  state = {
    loadScreen: "",
    modalProgress: false,
  }

  componentDidMount = () => { 
  }

  componentDidUpdate(prevProps) {
    // Cerrar el modal cuando ocurre un error
    if (this.props.error && !prevProps.error) {
      this.setChangeModal("modalProgress", false)
    }
  }

  UNSAFE_componentWillMount = () => {
    const {
      location: { search },
    } = this.props

    let loadScreen = search.split("=")[1]

    if(loadScreen === "ceased") {
      this.props.getCeasedSummaryWatcher()
    }
    if(loadScreen === "collaborators") {
      this.props.getCollaboratorsSummaryWatcher()
    }
    if(loadScreen === "teams") {
      this.props.getTeamsSummaryWatcher()
    }
    if(loadScreen === "divisions-assignment") {
      this.props.getDivisionsAssignmentSummaryWatcher()
    }
    
    this.setState({
      loadScreen: search.split("=")[1],
    })
  }

  setChangeModal = (name, value) => {
    this.setState({
      [name]: value,
    })
  }

  verifyDisabledButton = () => {
      return false
  }

  showSummary() {
    if(["teams"].includes(this.state.loadScreen)) {
      return (<SummaryScreen
        model="Colaboradores"
        gridHeader="120px 160px 160px 228px 1fr 24px"
        hideHeader
        onFinalize={(params) => {
          this.setChangeModal("modalProgress", true)
          this.props.saveTeamsWatcher(params)
        }}
        type="teams"
        disabledButton={this.verifyDisabledButton}
        header={[
          "Colaborador",
          "DNI del colaborador",
          "DNI del líder directo",
          "Error",
          "Fila",
        ]}
        gridContent="120px 160px 160px 228px 1fr 16px"
        content={[
          "fullname",
          "document",
          "dniBoss",
          "message",
          "row",
        ]}
        uploadTemplate={this.props.uploadTemplateTeamsWatcher}
        history={this.props.history}
        urlBack="/organization/collaborators/import?screen=teams"
        title="Carga líderes"
        count_import={this.props.summary[0].importLeaderCount}
        count_error={this.props.summary[0].notImportLeaderCount}
        count_update={this.props.summary[0].updateLeaderCount}
        count_delete={this.props.summary[0].deleteLeaderCount} 
        {...pick(this.props.summary[0], [
          "listErrors",
        ])}
        modalFinalize="teams"
      />)
    }

    if(["ceased"].includes(this.state.loadScreen)) {
      return <SummaryScreen
        model="Colaboradores"
        gridHeader="120px 160px 160px 228px 1fr 24px"
        hideHeader
        onFinalize={(params) => {
          this.setChangeModal("modalProgress", true)
          this.props.saveCollaboratorsCeased(params)
        }}
        disabledButton={this.verifyDisabledButton}
        header={[
          "DNI",
          "Nombre",
          "Apellido",
          "Email corporativo",
          "Error",
          "Fila",
        ]}
        gridContent="120px 160px 160px 228px 1fr 16px"
        content={[
          "document",
          "firstName",
          "lastName",
          "email",
          "message",
          "row",
        ]}
        uploadTemplate={this.props.uploadTemplateCeasedWatcher}
        history={this.props.history}
        urlBack="/organization#collaborators"
        title="Cesados"
        count_import={this.props.summary[0].count_cease}
        modalFinalize="collaborators-cease"
        {...pick(this.props.summary[0], [
          "count_error",
          "count_update",
          "listErrors",
          "measures_affected",
          "document",
        ])}
      />
    }

    if(["divisions-assignment"].includes(this.state.loadScreen)) {
      return <SummaryScreen
        model="Divisiones"
        gridHeader="120px 160px 160px 228px 1fr 24px"
        onFinalize={(params) => {
          this.setChangeModal("modalProgress", true)
          this.props.saveExcelDivisionsAssignmentWatcher(params)
          try {
            const response = assignDivisions();
          } catch (error) {
            console.error('Error:', error);
          }
        }}
        disabledButton={this.verifyDisabledButton}
        header={[
          "Nombre",
          "Apellidos",
          "DNI",
          "Error",
          "Fila"
        ]}
        gridContent="120px 160px 160px 228px 1fr 16px"
        content={[
          "firstName",
          "lastName",
          "document",
          "message",
          "row",
        ]}
        type="divisions-assignment"
        typeImport="divisions-assignment"
        uploadTemplate={this.props.uploadTemplateDivisionsAssignmentWatcher}
        history={this.props.history}
        urlBack="/organization/collaborators/import?screen=divisions-assignment"
        title="Asignación de divisiones"
        {...pick(this.props.summary[0], [
          "count_import",
          "count_error",
          "count_update",
          "listErrors",
          "document",
          "company_errors",
        ])}
      />
    }

    if(["collaborators"].includes(this.state.loadScreen)) {
      return <SummaryScreen
      action="Reintentar importar colaboradores"
      model="Colaboradores"
      gridHeader="160px 160px 120px 1fr 24px"
      header={["Nombre", "Apellidos", "DNI", "Error", "Fila"]}
      gridContent="160px 160px 120px 1fr 16px"
      content={["firstName", "lastName", "document", "message", "row"]}
      disabledButton={this.verifyDisabledButton}
      uploadTemplate={this.props.uploadTemplateCollaboratorsWatcher}
      onFinalize={(params) => {
        this.setChangeModal("modalProgress", true)
        this.props.saveExcelCollaboratorsWatcher(params)
      }}
      hasUpdates={this.props.hasCollaborators}
      history={this.props.history}
      urlBack="/organization#collaborators"
      title="Colaboradores"
      textResume={{
        text: "colaborador",
        success: (
          <React.Fragment>
            <span>{`${get(
              this.props.summary[0],
              "count_import",
              0
            )} `}</span>
            {`${plural(
              "colaborador",
              get(this.props.summary[0], "count_import", 0),
              "es"
            )} ${plural(
              "importado",
              get(this.props.summary[0], "count_import", 0),
              "s"
            )}`}
          </React.Fragment>
        ),
        failed: (
          <React.Fragment>
            <span>{`${get(
              this.props.summary[0],
              "count_error",
              0
            )} `}</span>
            {`${plural(
              "colaborador",
              get(this.props.summary[0], "count_error", 0),
              "es"
            )} sin importar`}
          </React.Fragment>
        ),
      }}
      {...pick(this.props.summary[0], [
        "count_import",
        "count_error",
        "count_update",
        "listErrors",
        "document",
        "company_errors",
      ])}
    />
    }
  }

  showSuccessMessage() {
    if(this.props.type === "teams") {
      return 'Ahora podrás visualizar los líderes de tu organización.'
    }

    if(["divisions-assignment"].includes(this.state.loadScreen)) {
      return 'Ahora podrás visualizar las divisiones a las que fue asignado cada colaborador.'
    }

    return 'Ahora podrás visualizar los colaboradores de tu organización.'
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Organización - Colaboradores</title>
          <meta
            name="description"
            content="Description of CollaboratorsSummary"
          />
        </Helmet>
        <>
          {this.props.isLoadingSummary ? <Loader /> : (
            this.showSummary()
          )}
        </>
        <Modal
          visible={this.state.modalProgress}
          okText="Aceptar"
          closable={false}
          footer={
            this.props.percentage !== 100
              ? null
              : [
                  <Button
                    key="submit"
                    type="primary"
                    id={this.state.loadScreen == "ceased" ? "btnAceptar" : ""}
                    onClick={() => {
                      this.setChangeModal("modalProgress", false)
                      this.props.history.push("/organization#collaborators")
                      setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT)
                    }}>
                    Aceptar
                  </Button>,
                ]
          }
          width={520}>
          {this.props.percentage !== 100 ? (
            <div className="modalSuccess">
              <Progress
                style={{ margin: "0 auto" }}
                width={80}
                type="circle"
                percent={this.props.percentage}
              />
              <span
                style={{
                  justifySelf: "center",
                  alignSelf: "center",
                  marginTop: "1em",
                  fontSize: "14px",
                  color: "#555151",
                }}>
                La importación puede tardar unos minutos...
              </span>
            </div>
          ) : (
            <div className="modalSuccess" style={{ textAlign: "center" }}>
              <img src={check} />
              <span
                style={{ marginTop: 14, fontWeight: 600, color: "#555151" }}>
                {this.state.loadScreen == "ceased"
                  ? "La importación de cesados ha sido completada con éxito."
                  : "La importación ha sido completada con éxito."}
              </span>
              <span
                style={{
                  justifySelf: "center",
                  alignSelf: "center",
                  marginTop: "1em",
                  fontSize: "14px",
                  color: "#555151",
                }}>
                {this.showSuccessMessage()}
              </span>
            </div>
          )}
        </Modal>
      </React.Fragment>
    )
  }
}

CollaboratorsSummary.propTypes = {
  getCollaboratorsSummaryWatcher: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  summary: makeSelectSummary(),
  isLoadingSummary: makeSelectIsLoadingSummary(),
  percentage: makeSelectPercentage(),
  hasCollaborators: makeSelectHasCollaborators(),
  error: makeSelectError(),
})

function mapDispatchToProps(dispatch) {
  return {
    getCollaboratorsSummaryWatcher: () =>
      dispatch(getCollaboratorsSummaryWatcher()),
    getDivisionsAssignmentSummaryWatcher: () => dispatch(getDivisionsAssignmentSummaryWatcher()),
    uploadTemplateCollaboratorsWatcher: (params) =>
      dispatch(uploadTemplateCollaboratorsWatcher(params)),
    uploadTemplateDivisionsAssignmentWatcher: (params) => dispatch(uploadTemplateDivisionsAssignmentWatcher(params)),
    uploadTemplateTeamsWatcher : (params) => dispatch(uploadTemplateTeamsWatcher(params)),
    saveExcelCollaboratorsWatcher: (params) =>
      dispatch(saveExcelCollaboratorsWatcher(params)),
    saveExcelDivisionsAssignmentWatcher: (params) => dispatch(saveExcelDivisionsAssignmentWatcher(params)),
    getCeasedSummaryWatcher: () => dispatch(getCeasedSummaryWatcher()),
    getTeamsSummaryWatcher: () => dispatch(getTeamsSummaryWatcher()),
    uploadTemplateCeasedWatcher: (params) =>
      dispatch(uploadTemplateCeasedWatcher(params)),
    saveCollaboratorsCeased: (params) =>
      dispatch(saveCollaboratorsCeasedWatcher(params)),
    saveTeamsWatcher: params => dispatch( saveTeamsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "collaboratorsSummary", reducer })
const withSaga = injectSaga({ key: "collaboratorsSummary", saga })

export default compose(withReducer, withSaga, withConnect)(CollaboratorsSummary)
